import { render, staticRenderFns } from "./ActList.vue?vue&type=template&id=97405d4a&scoped=true"
import script from "./ActList.vue?vue&type=script&lang=js"
export * from "./ActList.vue?vue&type=script&lang=js"
import style0 from "./ActList.vue?vue&type=style&index=0&id=97405d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97405d4a",
  null
  
)

export default component.exports